// Initialize Swiper for the review section
document.addEventListener('DOMContentLoaded', function () {
  const swiperReviews = new Swiper('.s-review-swiper', {
    loop: true,
    slidesPerView: 'auto',
    spaceBetween: 40,

    //autoplay: {
    //delay: 5000,
    //},
    // If we need pagination
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    // breakpoints: {
    //   1024: {
    //     slidesPerView: 'auto',
    //     spaceBetween: 40,
    //     // centeredSlides: true,
    //   },
    // },
  });
});
